import { render } from "./MintForm.vue?vue&type=template&id=4d35ad4b&scoped=true"
import script from "./MintForm.vue?vue&type=script&lang=js"
export * from "./MintForm.vue?vue&type=script&lang=js"

import "./MintForm.vue?vue&type=style&index=0&id=4d35ad4b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4d35ad4b"

export default script